// extracted by mini-css-extract-plugin
module.exports = {"title":"AddGroupStepper_title_f1TR0","pureLabelButton":"AddGroupStepper_pureLabelButton_3E0WN","backButton":"AddGroupStepper_backButton_35qnV"};